<template>
  <kendo-window ref="errors" :width="'600px'" :modal="true" :title="title" style="display:none">
    <div class="window-contents">
      <Grid v-if="isLoad" :data-source="errors" :height="420" id="errorGrid" :columns="result"></Grid>
    </div>
  </kendo-window>
</template>

<script>
import { Grid } from "@progress/kendo-grid-vue-wrapper";

export default {
  props: ["mode", "errors", "title"],
  data: function () {
    return {
      columns: [
        {
          field: "empID",
          title: "Employee Code",
          width: 100,
          hidden: false,
        },
        {
          field: "empName",
          title: "Name",
          width: 100,
          hidden: false,
        },
        {
          field: "email",
          title: "EmailID",
          width: 100,
          hidden: false,
        },
        {
          field: "cell",
          title: "Cell",
          width: 100,
          hidden: false,
        },
        {
          field: "error",
          title: "Error",
          width: 100,
          hidden: false,
        },
      ],
      result: [],
      isLoad: false,
    };
  },
  components: {
    Grid,
  },
  methods: {
    show() {
      this.$refs.errors.kendoWidget().center().open();
      let columData = this.errors[0];
      var keys = Object.keys(columData);
      this.result = keys
        .map((o) => this.columns.find((x) => x.field === o))
        .reverse();
      if (this.result.length != 0) {
        this.isLoad = true;
      }
    },
    close() {
      this.$refs.errors.kendoWidget().close();
    },
    getOnLoad() {},
  },
  computed() {
    this.getOnLoad();
  },
};
</script>

<style>
</style>